import React from 'react';

interface Props {
    step: number
    steps: number
    hideSteps?: boolean
}

const ProgressBar: React.FC<Props> = (props: Props) => {

    const donePercent = 100 * props.step / props.steps + "%"
    // const stepPercent = 100 * props.step / maxStepDone + "%"
    const barClass =  "rounded-full w-full bg-indigo-800" + (props.hideSteps ? "" : " ml-2")


    return (
        <div className="flex items-center">
          {
            !props.hideSteps &&
              <div className="z-title3 w-14">
                {props.step} / {props.steps}
              </div>
          }

          <div className={barClass}>
            <div className="h-2 rounded-full bg-success-500" style={{width: donePercent}}>
                    {/*<div className="h-2 rounded-full bg-success-500" style={{width: stepPercent}}/>*/}
                </div>
            </div>
        </div>
    )
}

export default ProgressBar;